import useResizeWindow from "../../hooks/useResizeWindow";
import logoIcon from "../../assets/img/logo.svg";
import whiteLogoIcon from "../../assets/img/white-logo.svg";
import "./styles.css";

const Header = () => {
  const { width } = useResizeWindow();

  const renderLogo = () => {
    if (width <= 445) {
      return <img alt="logo" src={logoIcon} />;
    }
    return <img alt="white-logo" src={whiteLogoIcon} />;
  };

  return <div className="header">{renderLogo()}</div>;
};

export default Header;
